module.exports = __webpack_public_path__ + "img/accuctp.03f25ed5.png";